<template>
  <b-row>
    <b-col
      cols="12"
      md="8"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <!-- Thumbnail -->
              <b-form-group
                label="Thumbnail"
                label-for="v-image_id"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.media.title"
                    :description="labelForm.media.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.media.title"
                  rules="required"
                >
                  <form-image
                    v-model="form.image"
                    label="Pilih Gambar"
                    :state="errors.length > 0 ? false : null"
                    width-full
                    with-endpoin
                    aspect-ratio="2/1"
                    @finish="onInputImage"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Title -->
              <b-form-group
                label-for="v-title"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.title.title"
                    :description="labelForm.title.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.title.title"
                  rules="required"
                >
                  <b-form-input
                    id="v-title"
                    v-model="form.title"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Slug -->
              <b-form-group
                label-for="v-slug"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.slug.title"
                    :description="labelForm.slug.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.slug.title"
                  rules="required"
                >
                  <b-form-input
                    id="v-slug"
                    v-model="form.slug"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Content -->
              <b-form-group
                label-for="v-body"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.content.title"
                    :description="labelForm.content.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.content.title"
                  rules="required"
                >
                  <quill-editor
                    id="v-body"
                    v-model="form.body"
                    class="long-height"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Type -->
              <b-form-group
                label-for="v-type"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.type.title"
                    :description="labelForm.type.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.type.title"
                  rules="required"
                >
                  <v-select
                    v-model="category"
                    label="name"
                    :options="articleCategories.data"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Pilih Tipe Kategori"
                    multiple
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Brand -->
              <b-form-group
                label-for="v-type"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.merchant.title"
                    :description="labelForm.merchant.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.merchant.title"
                >
                  <select-data-input
                    v-model="merchant"
                    name="merchant"
                    label-data="name"
                    search-to-load
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Publish -->
              <b-form-group
                label-for="v-publish"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.publish.title"
                    :description="labelForm.publish.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="labelForm.publish.title"
                >
                  <b-form-checkbox
                    v-model="form.is_active"
                    name="check-button"
                    switch
                    inline
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div v-if="category.length && category.find(el => el.id === 2)">
                <hr>
                <h3 class="mb-2">
                  Informasi Lanjutan
                </h3>

                <b-form-group
                  label-for="v-type"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.highlight.title"
                      :description="labelForm.highlight.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    :name="labelForm.highlight.title"
                  >
                    <b-form-checkbox
                      id="v-highlight"
                      v-model="form.highlight"
                      :checked="form.highlight"
                      switch
                      inline
                    >
                      Highlight
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Photo Registry -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-registry_photo"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.registry_photo.title"
                      :description="labelForm.registry_photo.description"
                      :required="form.highlight"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    :name="labelForm.registry_photo.title"
                    :rules="form.highlight ? 'required' : ''"
                  >
                    <form-image
                      v-model="form.registry_photo_file"
                      label="Pilih Gambar"
                      :state="errors.length > 0 ? false : null"
                      :width="300"
                      with-endpoin
                      aspect-ratio="1/1"
                      @finish="onInputImageRegistry"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Title Registry -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-registry_title"
                  label-cols-md="4"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.registry_title.title"
                      :description="labelForm.registry_title.description"
                      :required="form.highlight"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    :name="labelForm.registry_title.title"
                    :rules="form.highlight ? 'required' : ''"
                  >
                    <b-form-input
                      id="v-registry_title"
                      v-model="form.registry_title"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="form.highlight ? '' : 'Opsional'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Registry Owner -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-registry_owner"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.user.title"
                      :description="labelForm.user.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    :name="labelForm.user.title"
                    :rules="form.highlight ? 'required' : ''"
                  >
                    <b-form-input
                      id="v-registry_owner"
                      v-model="form.registry_owner"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="form.highlight ? '' : 'Opsional'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Urutan -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-tag"
                  label-cols-md="4"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.order.title"
                      :description="labelForm.order.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    :name="labelForm.order.title"
                    rules="min_value:1|integer|required"
                  >
                    <b-form-input
                      id="v-title"
                      v-model="form.order"
                      :state="errors.length > 0 ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

              </div>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import vSelect from 'vue-select'
import FormImage from '@/layouts/components/custom/FormImage.vue'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FormLabel from '@/layouts/components/custom/FormLabel.vue'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'
import SelectDataInput from '../custom/SelectDataInput.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    BFormCheckbox,

    ValidationProvider,
    ValidationObserver,

    vSelect,
    FormImage,
    quillEditor,
    FormLabel,
    SelectDataInput,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        image_id: undefined,
        image: undefined,
        title: undefined,
        slug: undefined,
        body: undefined,
        article_category_id: [],
        is_active: false,
        highlight: false,
        order: null,
        registry_title: undefined,
        registry_photo: undefined,
        registry_photo_file: undefined,
        registry_owner: undefined,
        merchant_id: undefined,
      },
      category: [],
      merchant: undefined,
      title: '',
      required,
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('article', ['article', 'labelForm']),
    ...mapState('articleCategory', ['articleCategories']),
    articleId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  watch: {
    category(value) {
      if (value.length) this.form.article_category_id = value.map(el => el.id)
    },
    form: {
      handler(val) {
        if (val.title) {
          const text = this.form.title.toLowerCase()
          this.form.slug = text.replaceAll(' ', '-')
        }
      },
      deep: true,
    },
  },
  async created() {
    this.isPending = true
    this.getCategoriesArticle({ limit: 50 })
    if (this.isEdit) {
      await this.getArticle({ id: this.articleId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('articleCategory', ['getCategoriesArticle']),
    ...mapActions('article', ['createArticle', 'updateArticle', 'getArticle']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    setImageFile(file) {
      if (file) {
        this.form.imageFile = file
      }
    },
    async handleSubmit() {
      this.isSubmitting = true

      const productCount = await this.countingProductBody(this.form.body)

      const form = { ...this.form }

      if (!this.category.length || !this.category.find(el => el.id === 2) || !form.order || !form.highlight) {
        form.order = null
        form.registry_title = null
        form.registry_owner = null
      }

      const data = {
        ...form,
        is_active: form.is_active ? 1 : 0,
        product_count: productCount,
        merchant_id: this.merchant ? this.merchant.id : null,
      }

      // eslint-disable-next-line no-unreachable
      if (!this.isEdit) {
        const res = await this.createArticle(data)
        this.isSubmitting = false
        if (res) this.$router.push('/articles')
      } else {
        const res = await this.updateArticle({ articleId: this.articleId, data })
        this.isSubmitting = false
        if (res) this.$router.push('/articles')
      }
    },
    // Edit State Only
    fillData() {
      this.form.thumbnail = this.article.thumbnail
      this.form.title = this.article.title
      this.form.slug = this.article.slug
      this.form.body = this.article.body
      this.category = this.article.category
      this.form.article_category_id = this.article.category.map(el => el.id)
      this.form.is_active = !!this.article.is_active
      this.form.image = this.linkStaging(this.article.primary_image, 100, 100)

      if (this.article.merchant) this.merchant = this.article.merchant

      if (this.category.length && this.category.find(el => el.id === 2)) {
        this.form.order = this.article.order

        if (this.article.order) {
          this.form.highlight = true
          this.form.registry_title = this.article.registry_title
          this.form.registry_owner = this.article.registry_owner
          this.form.registry_photo_file = this.linkStaging(this.article.registry_photo, 100, 100)
          // this.form.registry_photo = this.article.registry_photo
        }
      }
    },
    async onInputImage(data) {
      const datas = await JSON.parse(JSON.stringify(data))
      this.form.image_id = datas.id
    },
    async onInputImageRegistry(data) {
      const datas = await JSON.parse(JSON.stringify(data))
      this.form.registry_photo = datas.id
    },
    async countingProductBody() {
      if (this.form.body) {
        const listRawContent = await this.form.body.match(/\{\{.*?\}}|.+?(?=\{{|$)/g)
        const articleContent = await this.initListContent(listRawContent)
        const linkList = await articleContent.filter(el => el.link)

        return linkList.length
      }
      return 0
    },
    async initListContent(data) {
      return data.map(el => {
        if (el.includes('{{')) {
          const link = el.replace('{{', '').replace('}}', '')
          const slug = link.split('/').pop()
          return {
            link: true,
            content: link,
            slug,
          }
        }

        return {
          link: false,
          content: el,
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
